// pages/Register.jsx
import React from "react";
import RegisterForm from "../components/RegisterForm";

export default function Register() {
  return (
      <RegisterForm />               
  );
}
